export default __webpack_public_path__ + "static/media/section2_4_3_m.22e2565b.png";